(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['angular'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('angular'));
  } else {
    // Browser globals (root is window)
    root.returnExports = factory(root.angular);
  }
} (this, function (angular) {

  'use strict';

  /**
   * @ngdoc service
   * @Loads in google docs for data code
   * # gdocsLoader
   */
  var app = angular.module('angularDatacenterLoader', [])
    .config(['$httpProvider', function($httpProvider) {
      $httpProvider.interceptors.push('jsonpInterceptor');
    }])
    // use custom callback names for medicare json data
    // see http://stackoverflow.com/questions/25400891/how-to-custom-set-angularjs-jsonp-callback-name
    .factory('jsonpInterceptor', ['$window', '$q', '$rootScope',
      function($window, $q, $rootScope) {
        return {
          request: function(config) {
            if (config.method === 'JSONP') {
              var callbackId = angular.callbacks.counter.toString(36);
              config.callbackName = config.callbackName || 'JSON_CALLBACK';
              config.url = config.url.replace('JSON_CALLBACK', config.callbackName);

              // @TODO - at some point we can send this through an ES6 preprocessor
              $rootScope.$watch(
                function() {
                  return angular.callbacks;
                },
                function() {
                  $window[config.callbackName] =
                    angular.callbacks['_' + callbackId];
                }
              );
            }

            return config;
          },

          response: function(response) {
            var config = response.config;
            if (config.method === 'JSONP') {
              delete $window[config.callbackName]; // cleanup
            }

            return response;
          },

          responseError: function(rejection) {
            var config = rejection.config;
            if (config.method === 'JSONP') {
              delete $window[config.callbackName]; // cleanup
            }

            return $q.reject(rejection);
          }
        };
      }
    ])
    .service('Loader', ['$http', '$q', '$window', '$location', '$timeout',
      function gdocsLoader($http, $q, $window, $location, $timeout) {
        // Returns a single promise to resolver
        this.get = function() {
          var q = $q.defer(),
            _this = this;

          var localDataSource = $location.search().localDataSource || false;

          // Use data object from transient cache, or try hitting middleware directly
          if (($window.appJs || {}).dsn && ($window.appJs || {}).geo_url) {
            this.medicareData().then(function(data) {
              q.resolve(data);
            });
          } else if (!($window.appJs || {}).gdocsObject && !localDataSource) {
            this.spreadsheetData().then(function(data) {
              q.resolve(data);
            });
          } else if (localDataSource) {
            $http.jsonp('/wp-content/themes/vip/kaiser-foundation-2016/static/js/apps/datacenter/sample_data/' + localDataSource + '?callback=JSON_CALLBACK')
              .success(function(data) {
                q.resolve(data);
              });
          } else {
            q.resolve($window.appJs.gdocsObject);
          }

          return q.promise;
        };

        this.medicareData = function() {
          var q = $q.defer();

          // Ugly nested promises because of custom callback wonkery
          // Also, generated JSON should have proper labels mapped on already
          $http.jsonp($window.appJs.geo_url + '?callback=JSON_CALLBACK', { callbackName: 'kff_load_medicare_geos' })
            .then(function(geoDefinitions) {
              $http.jsonp($window.appJs.dsn + '?callback=JSON_CALLBACK', { callbackName: 'kff_indicator_data' })
                .then(function(data) {
                  q.resolve({
                    data: data.data,
                    geoDefinitions: geoDefinitions.data
                  });
                })
            });

          return q.promise;
        }
        // Pull titles and feed in from spreadsheet
        this.spreadsheetData = function() {
          var q = $q.defer();

          $http.jsonp(this.URL)
            .success(function(data) {
              q.resolve(data);
            })
            .error(function() {
              q.reject('Error Retrieving Data');
            });

          return q.promise;
        };

      }
    ])
}));



/*****************
 ** WEBPACK FOOTER
 ** ../angular_modules/angular-datacenter-loader/angular-datacenter-loader.js
 ** module id = 152
 ** module chunks = 2
 **/